
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import RegistroPresolicitud from "../../models/RegistroPresolicitud";
import Presolicitud from "../../models/Presolicitud";

import AfiliadoService from "@/services/AfiliadoService";
import RegistroDocumentosPresolicitud from "../../models/RegistroDocumentosPresolicitud";
import { AxiosResponse } from "axios";
import ServiceResponse from "@/services/response-models/ServiceResponse";
import ServiceResponseSolicitudes from "@/services/response-models/ServiceResponseSolicitudes";
import ServiceResponseArchivos from "@/services/response-models/ServiceResponseArchivos";
import CatalogoResponse from "../../models/CatalogoResponse";
import ServiceResponseEntity from "@/services/response-models/ServiceResponseEntity";
import DocumentoPresolicitud from "@/models/DocumentoPresolicitud";
import Swal from "sweetalert2";
import { Getter } from "vuex-class";
import TipoBeneficioEnum from "@/enums/TipoBeneficioEnum";
import { VueFilePondComponent } from "vue-filepond";
import VeeValidateForm from "@/vee-validate/types/VeeValidateForm";
import ParametrosObtencionPresolicitud from "@/models/ParametrosObtencionPresolicitud";
import FileConfig from "../../FileConfig";
import { formatCedula } from "@/utils/HelperFunctions";
import SobrevivenciaService from "@/services/SobrevivenciaService";
import EtapaRequest from "@/models/Sobrevivencia/SobrevivenciaPresolicitud/EtapaRequest";
import GlobalConfig from "@/GlobalConfig";
import User from "@/models/User";
import Aterisk from "@/components/sobrevivencia/Aterisk.vue";
import ConsultaFallecido from "@/models/ConsultaFallecido";
import { reemplazarCaracteresEspeciales } from "@/utils/HelperFunctions";
import { sanitizeFileName } from "@/utils/SanitizeFileName";
import EmailValidator from "@/utils/EmailValidator";
@Component({ components: { Aterisk } })
export default class RegistroFallecimiento extends Vue {
  @Prop({}) triggerRegister: boolean;
  public consultaFallecido: ConsultaFallecido = new ConsultaFallecido();
  public afiliadoService: AfiliadoService = new AfiliadoService();
  public documentos: Array<File> = [];
  public registroPresolicitud: RegistroPresolicitud =
    new RegistroPresolicitud();
  public registroDocumentosPresolicitud: RegistroDocumentosPresolicitud =
    new RegistroDocumentosPresolicitud();
  public parentescos: Array<CatalogoResponse> = [];
  public parentescosLoading: boolean = false;
  public parentesco: CatalogoResponse = null;
  public numeroSolicitud: number = null;
  public archivosRemovidos: Array<DocumentoPresolicitud> = [];
  public archivos: Array<DocumentoPresolicitud> = [];
  @Getter("cedulaFallecido") cedulaFallecido: string;
  @Getter("requiereDocumento") requiereDocumento: boolean;
  @Getter("user") user: User;
  public showFileRequiredError: boolean = false;
  public showInvalidFileTypeError: boolean = false;
  public showInvalidFileSizeError: boolean = false;
  public showServerError: boolean = false;
  public showServerValidationMessage: boolean = false;
  public serverValidationMessage = "";
  public isEditing = false;
  public loadingData = false;
  public currentPresolicitud: Presolicitud = new Presolicitud();
  public fileConfig: FileConfig = new FileConfig();
  public sobrevienciaService: SobrevivenciaService = new SobrevivenciaService();
  public viasNotificacion: Array<CatalogoResponse> = [];
  public viasNotificacionLoading: boolean = false;
  public viaNotificacion: CatalogoResponse = null;
  public modificaValorViaNotificacion: boolean = false;
  public valorViaNotificacion: string = null;
  public reemplazarCaracteresEspeciales = reemplazarCaracteresEspeciales;

  @Getter("isLoggedIn") isLoggedIn: boolean;

  get saveButtonText(): string {
    return this.isEditing ? "Guardar" : "Registrar";
  }

  get successOperationMessage(): string {
    return this.isEditing ? "Operación exitosa" : "Fallecimiento registrado";
  }

  get saveButtonIsDisable(): boolean {
    return this.isEditing && !this.currentPresolicitud.esModificable;
  }

  get nombreAfiliado() {
    return (
      this.currentPresolicitud.nombreAfiliado ||
      this.$store.getters.nombreAfiliadoFallecido
    );
  }

  get cedulaAfiliadoFallecido() {
    return (
      this.currentPresolicitud.cedulaAfiliado ||
      this.$store.getters.cedulaFallecido
    );
  }

  @Watch("showInvalidFileTypeError")
  public async onInvalidFileType(newValue, oldValue) {
    let invalidClass = "invalid-file";
    let element = (this.$refs.pond as VueFilePondComponent).$el as HTMLElement;
    if (newValue) {
      let classList = element.className.split(" ");
      if (classList.indexOf(invalidClass) == -1) {
        element.className += " " + invalidClass;
      }
    } else {
      let classList = element.className.split(" ");
      let classIndex = classList.indexOf(invalidClass);
      classList.splice(classIndex, 1);
      element.className = classList.join(" ");
    }
  }

  public async mounted() {
    let cedulaUsuario = this.$store.getters.user.cedula;
    // Validate if user can proceed
    if (this.cedulaAfiliadoFallecido == cedulaUsuario) {
      Swal.fire({
        text: "El usuario consultante no puede ser el mismo afiliado fallecido.",
        icon: "error",
        showConfirmButton: false,
        timer: 8000,
        onClose: () => {
          this.$router.push("/solicitudes-beneficiario");
        },
      });
    }
    this.scrollToTop();
    await this.getParentescos();

    if (this.$route.query.numeroSolicitud) {
      this.numeroSolicitud = Number(this.$route.query.numeroSolicitud);
      if (this.numeroSolicitud) {
        this.isEditing = true;
        this.loadingData = true;
        await this.getPresolicitud();
        await this.getDocumentosPresolicitud();
      }
    }
    await this.getViasNotificacion();

    // Acá se carga la via de notificacion pro default ya sea del usuario o de la propia solicitud
    if (
      this.currentPresolicitud.viaNotificacion != null &&
      this.currentPresolicitud.viaNotificacion.length > 0
    ) {
      this.viaNotificacion = this.viasNotificacion.find(
        (x) => x.value === this.currentPresolicitud.viaNotificacion
      );
    } else if (this.user.viaNotifi != null && this.user.viaNotifi.length > 0) {
      this.viaNotificacion = this.viasNotificacion.find(
        (x) => x.value === this.user.viaNotifi
      );
    }
  }

  public async getParentescos(term: string = null) {
    if (term && term.length <= 3) {
      return;
    }

    this.parentescosLoading = true;
    const response = await this.afiliadoService.parentescosSobrevivencia(term);
    if (response.data.entity) {
      this.parentescos = response.data.entity;
    } else {
      this.parentescos = [];
    }
    this.parentescosLoading = false;

    ///
  }

  public async getPresolicitud() {
    this.afiliadoService
      .getPresolicitud(
        new ParametrosObtencionPresolicitud(
          this.numeroSolicitud,
          this.$store.getters.user.cedula,
          null,
          null
        )
      )
      .then((response: AxiosResponse<ServiceResponseSolicitudes>) => {
        if (response.data.solicitudes && response.data.solicitudes.length > 0) {
          this.currentPresolicitud = response.data.solicitudes.find(
            (x) => x.numeroSolicitud == this.numeroSolicitud
          );
          if (this.currentPresolicitud) {
            this.parentesco = this.parentescos.find(
              (x) => x.value === this.currentPresolicitud.parentesco
            );
            this.registroPresolicitud.presolicitud.observaciones =
              this.currentPresolicitud.observaciones;
            this.registroPresolicitud.presolicitud.cedulaAfiliado =
              this.currentPresolicitud.cedulaAfiliado;
            this.registroDocumentosPresolicitud.cedulaFallecido =
              this.currentPresolicitud.cedulaAfiliado;
          }
        } else {
          // this.$router.push("/solicitudes-beneficiario");
        }
      });
  }

  public async getDocumentosPresolicitud() {
    this.afiliadoService
      .getDocumentosPresolicitud(this.numeroSolicitud)
      .then((response: AxiosResponse<ServiceResponseArchivos>) => {
        this.archivos = response.data.archivos.filter((x) => x.codEtapa == 1);
      })
      .finally(() => {
        this.loadingData = false;
      });
  }

  public onAddOrRemoveFile(): void {
    let pond: any = this.$refs.pond;
    this.documentos = pond.getFiles().map((x) => {
      const file = x.file;
      const sanitizedName = sanitizeFileName(file.name);
      return new File([file], sanitizedName, {
        type: file.type,
        lastModified: file.lastModified,
      });
    });
    this.showFileRequiredError = true;
    const anyFileTypeInvalid: boolean = this.documentos.some(
      (x) => !this.fileConfig.allowedFileTypes.includes(x.type)
    );
    this.showInvalidFileTypeError = anyFileTypeInvalid;
    const anyFileSizeInvalid: boolean = this.documentos.some(
      (x) => x.size / 1000000 > this.fileConfig.fileSizeMbLimit
    );
    const anyFileExtensionInvalid: boolean = this.documentos.some((x) =>
      this.fileConfig.notAllowExtensions.some((substring) =>
        x.name.includes(substring)
      )
    );

    if (anyFileExtensionInvalid) {
      this.showInvalidFileTypeError = anyFileExtensionInvalid;
      //Set others Validations message to false
      this.showInvalidFileSizeError = false;
    }
    this.showInvalidFileSizeError = anyFileSizeInvalid;
    this.showServerValidationMessage = false;

    if (this.documentos.length > 0) {
      let filteredName = this.reemplazarCaracteresEspeciales(
        this.documentos[0].name
      );
      console.log("filtered name " + filteredName);
      this.documentos[0] = new File([this.documentos[0]], filteredName, {
        type: this.documentos[0].type,
      });
    }
  }

  public async register() {
    const anyFile: boolean = !(
      this.archivos.length === 0 && this.documentos.length === 0
    );
    if (!anyFile) {
      this.showFileRequiredError = true;
      this.scrollToActa();
      return;
    }
    const anyFileTypeInvalid: boolean = this.documentos.some(
      (x) => !this.fileConfig.allowedFileTypes.includes(x.type)
    );
    if (anyFileTypeInvalid) {
      this.showInvalidFileTypeError = true;
      this.scrollToActa();
      return;
    }
    (this.$refs.fallecidosForm as VeeValidateForm)
      .validate()
      .then((isValid: boolean) => {
        const hasParentesco: boolean = !!this.parentesco;
        if (!this.saveButtonIsDisable) {
          if (isValid && hasParentesco) {
            if (true) {
              Swal.fire({
                text: "Se están registrando los datos",
                icon: "info",
                timerProgressBar: true,
                onBeforeOpen: () => {
                  Swal.showLoading();
                },
                allowOutsideClick: false,
              });
              this.registroPresolicitud = this.setRegistroPresolicitud();
              this.registroPresolicitud.archivosEliminados =
                this.archivosRemovidos;

              //validar que no haya reportado esta persona antes.
              this.consultaFallecido.cedulaBeneficiario = this.user.cedula;
              this.consultaFallecido.cedulaFallecido =
                this.cedulaAfiliadoFallecido;
              this.afiliadoService
                .consultarAfiliadoFallecido(this.consultaFallecido)
                .then((response) => {
                  let result = response.data;
                  //
                  switch (result.respCode) {
                    case 400:
                      let errorMessage = this.isLoggedIn
                        ? "Ya has reportado el fallecimiento de este afiliado."
                        : "Este afiliado ya ha sido reportado por este beneficiario.";
                      Swal.fire({
                        text: errorMessage,
                        icon: "error",
                        showConfirmButton: false,
                        timer: 3000,
                      });
                      break;

                    case 200:
                      this.afiliadoService
                        .registroPresolicitud(this.registroPresolicitud, {
                          actaDefuncion: this.documentos,
                        })
                        .then((response: AxiosResponse<ServiceResponse>) => {
                          if (response.data.respCode === 200) {
                            Swal.close();
                            this.numeroSolicitud =
                              response.data.numeroSolicitud;
                            this.setEtapa({
                              numPresolicitud: response.data.numeroSolicitud,
                              etapa: 1,
                            });
                            this.onRegisterSuccessful();
                          } else if (response.data.respCode === 400) {
                            Swal.close();

                            this.serverValidationMessage =
                              response.data.message;
                            this.showServerValidationMessage = true;
                            this.scrollToTop();
                          } else {
                            Swal.close();
                            Swal.fire({
                              text: "Ha ocurrido un error, inténtalo de nuevo",
                              icon: "error",
                              showConfirmButton: false,
                              timer: 3000,
                            });
                            this.scrollToTop();
                          }
                        })
                        .catch(() => {
                          Swal.close();
                          this.showServerError = true;
                        });

                      break;
                  }
                })
                .catch((error) => {
                  console.error(error);
                });
              // console.log("sigue con el registro")
              /////////////////////////
            } else {
              this.scrollToTop();
            }
          } else {
            this.scrollToTop();
          }
        }
      })
      .catch(() => {
        Swal.close();
        Swal.fire({
          text: "Ocurrió un error validando el formulario, inténtalo de nuevo",
          icon: "error",
          showConfirmButton: false,
          timer: 3000,
        });
      });
  }

  public getFileName(fileUrl: string): string {
    if (fileUrl.includes("/")) {
      const fileName = fileUrl.split("/");
      return fileName[fileName.length - 1];
    } else {
      return fileUrl;
    }
  }

  public setRegistroPresolicitud(): RegistroPresolicitud {
    const registroPresolicitud: RegistroPresolicitud =
      new RegistroPresolicitud();
    registroPresolicitud.presolicitud.tipoBeneficio =
      TipoBeneficioEnum.Fallecimiento.toString();
    registroPresolicitud.presolicitud.numeroSolicitud = this.numeroSolicitud;
    registroPresolicitud.presolicitud.codCuenta =
      this.$store.state.user.codCuenta;
    registroPresolicitud.presolicitud.cedulaBeneficiario =
      this.$store.state.user.cedula /* '40213282383' */;
    registroPresolicitud.presolicitud.parentesco = this.parentesco.value;
    registroPresolicitud.presolicitud.observaciones =
      this.registroPresolicitud.presolicitud.observaciones;
    if (!this.isEditing) {
      registroPresolicitud.presolicitud.cedulaAfiliado =
        this.cedulaFallecido /* '00101612232' */;
      this.registroDocumentosPresolicitud.cedulaFallecido =
        this.cedulaFallecido /* '00101612232' */;
      // console.log(this.cedulaFallecido + " CEDULA FALLECIDO");
    }

    this.registroDocumentosPresolicitud.tipoBeneficio =
      TipoBeneficioEnum.Fallecimiento;
    this.registroDocumentosPresolicitud.numeroSolicitud = this.numeroSolicitud;
    registroPresolicitud.registroDocumentosPresolicitud =
      this.registroDocumentosPresolicitud;

    //via notificacion
    if (this.viaNotificacion) {
      registroPresolicitud.presolicitud.viaNotificacion =
        this.viaNotificacion.value;
      var valorViaNotificacion =
        this.valorViaNotificacion || this.valorViaNotificacionActual;
      //
      if (this.viaNotificacion) {
        switch (this.viaNotificacion.value) {
          case "E":
            const error = EmailValidator.validate(valorViaNotificacion);
            if (error) {
              Swal.fire({
                icon: "error",
                text: `El correo ingresado no es válido: ${error}`,
                confirmButtonText: "Ok",
              });
              return;
            }
            registroPresolicitud.presolicitud.eMail = valorViaNotificacion;
            this.user.correoElectronico1 = valorViaNotificacion;
            break;
          case "C":
            registroPresolicitud.presolicitud.numTelefono =
              valorViaNotificacion;
            this.user.celular = valorViaNotificacion;
            break;
          default:
            break;
        }
      }
    }
    return registroPresolicitud;
  }

  public scrollToTop(): void {
    const top = this.$refs.top as any;
    setTimeout(() => {
      top.scrollIntoView({ behavior: "smooth" });
    }, 500);
  }

  public scrollToActa(): void {
    const cintilloActa = this.$refs.cintilloActa as any;
    cintilloActa.scrollIntoView({ behavior: "smooth" });
  }

  public onRegisterSuccessful(): void {
    Swal.fire({
      text: this.successOperationMessage,
      icon: "success",
      showConfirmButton: false,
      timer: 2000,
      onClose: () => {
        const routeBenefactor = this.$route.query.beneficiario as string;

        this.$router.push({
          path: "registro-sobrevivencia",
          query: {
            numeroSolicitud: this.numeroSolicitud.toString(),
            ...(routeBenefactor ? { beneficiario: routeBenefactor } : {}),
          },
        });
        this.$emit("registerSccesful");
      },
    });
  }

  public onRemoveArchivo(archivoPresolicitud: DocumentoPresolicitud): void {
    const fileName: string = this.getFileName(archivoPresolicitud.ruta);
    Swal.fire({
      text: "¿Deseas eliminar el archivo " + fileName + " ?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#ED8B2F",
      cancelButtonColor: "#0F6CBC",
      confirmButtonText: "OK",
      reverseButtons: true,
    }).then((result) => {
      if (result.value) {
        const index: number = this.archivos.indexOf(archivoPresolicitud);
        this.archivos.splice(index, 1);
        this.archivosRemovidos.push(archivoPresolicitud);
      }
    });
  }

  public openRequisitosInNewTab() {
    window.open(
      "https://afpsiembra.com/media/Formulario_Beneficios_por_Sobrevivencia_(web).pdf",
      "_blank"
    );
  }

  public redirectToSolicitudesBeneficiario() {
    this.$router.push("/solicitudes-beneficiario");
  }

  public formatUserCedula(cedula: string): string {
    return formatCedula(cedula);
  }

  @Watch("triggerRegister")
  public triggerRegisterWatch() {
    this.register();
  }

  public async setEtapa(data: { numPresolicitud: number; etapa: number }) {
    let request: EtapaRequest = new EtapaRequest();
    (request.numPreSolicitud = data.numPresolicitud),
      (request.codEtapa = data.etapa);
    request.codUsuario = this.cedulaAfiliadoFallecido;
    this.sobrevienciaService
      .setEtapa(request)
      .then((response) => {
        // console.log(response);
      })
      .catch((error) => {
        console.log("F updating etapa");
      });
  }
  public goToOficinas() {
    window.location.href =
      GlobalConfig.PUBLIC_WEB_URL + "/empresas/vias-de-contacto/";
  }

  //Via notificacion
  @Watch("viaNotificacion")
  public onViaNotificacionSelected(
    newValue: CatalogoResponse,
    oldValue: CatalogoResponse
  ): void {
    if (!!oldValue) {
      this.modificaValorViaNotificacion = false;
      this.valorViaNotificacion = null;
    }
  }

  public async getViasNotificacion(term: string = null) {
    if (term && term.length <= 3) {
      return;
    }

    this.viasNotificacionLoading = true;
    const response = await this.afiliadoService.viasNotificacion(term);
    if (response.data.entity) {
      this.viasNotificacion = response.data.entity;
    } else {
      this.viasNotificacion = [];
    }
    this.viasNotificacionLoading = false;
  }
  get valorViaNotificacionActual(): string {
    if (this.viaNotificacion) {
      switch (this.viaNotificacion.value) {
        case "E":
          return this.user.correoElectronico1 || this.user.correoElectronico2;
        case "C":
          return this.user.celular;
        default:
          return;
      }
    } else {
      return null;
    }
  }
}
